import React from "react";
import Loading from "components/dumb/loading/Loading";
import { Typography, Box } from "@mui/material";
import { useParams } from "react-router-dom";

// Local Imports
import CreateLeavePolicyEntitlement from "module/leave/pages/createLeavePolicy/view/withEntitlement";
import CreateLeavePolicyWithoutEntitlement from "../withoutEntitlement";

// API Services
import { useShowLeavePolicy } from "services/api/modules/leave/leavePolicy";

const EditLeavePolicy = () => {
  const params = useParams();

  const { data: policy, isLoading, error } = useShowLeavePolicy(params.id);

  if (isLoading) {
    return <Loading show />;
  }

  if (error) {
    <Box
      width="100vw"
      height="100vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Typography>
        there is something wrong with this page. Please report to our team for
        help
      </Typography>
    </Box>;
  }

  return (
    <>
      {policy.type === 1 && (
        <CreateLeavePolicyEntitlement editMode policy={policy} />
      )}
      {policy.type === 2 && (
        <CreateLeavePolicyWithoutEntitlement editMode policy={policy} />
      )}
    </>
  );
};

export default EditLeavePolicy;
